module.exports = __webpack_public_path__ + "static/media/CHAPKA.cfcc6c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/CHAPKA.png
// module id = 92
// module chunks = 48